import { render, staticRenderFns } from "./RequestUpgradeRoleSection.vue?vue&type=template&id=1e1b85ea"
import script from "./RequestUpgradeRoleSection.vue?vue&type=script&lang=js"
export * from "./RequestUpgradeRoleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports